export default __webpack_public_path__ + "static/media/stitching_frame_metal.0e3e76fe.svg";